import RequestAbstract from "../abstract";

export default class WalletCoupons extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/wallet-coupons";
    }
}
